import { render, staticRenderFns } from "./tabQuery.vue?vue&type=template&id=2cf4b7bc&scoped=true&"
import script from "./tabQuery.vue?vue&type=script&lang=js&"
export * from "./tabQuery.vue?vue&type=script&lang=js&"
import style0 from "./tabQuery.vue?vue&type=style&index=0&id=2cf4b7bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4b7bc",
  null
  
)

export default component.exports